import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Antd, {message} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import VueClipboard from 'vue-clipboard2';

Vue.config.productionTip = false
Vue.use(Antd);
Vue.use(VueClipboard);
message.config({
  maxCount: 1,
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
